module.exports = __webpack_public_path__ + "img/appstore.33a65252.svg";